exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-estimated-actual-cell div {\n  background: #eeeeee;\n  height: 100%;\n  width: -webkit-fill-available;\n  width: -moz-available;\n  min-width: 80px;\n  padding: 4px;\n  text-align: left; }\n  app-estimated-actual-cell div.actual {\n    background: #ccf0d9;\n    color: #4daf51; }\n    app-estimated-actual-cell div.actual .mat-icon {\n      color: #4daf51;\n      height: 16px;\n      width: 16px;\n      vertical-align: bottom; }\n  app-estimated-actual-cell div .value {\n    margin: 0 8px; }\n", ""]);

// exports
